import React from 'react';
import { Link } from 'react-router-dom';

const CGV = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Breadcrumb */}
        <nav className="flex mb-8" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-4">
            <li>
              <Link to="/" className="text-gray-400 hover:text-gray-500">
                Accueil
              </Link>
            </li>
            <li>
              <svg className="flex-shrink-0 h-5 w-5 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
            </li>
            <li>
              <span className="text-gray-700 font-medium">Conditions générales de vente</span>
            </li>
          </ol>
        </nav>

        {/* Header */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Conditions générales de vente</h1>
          <p className="text-gray-600">
            Conditions applicables à la vente de générateurs d'eau atmosphérique ECOCLIMA
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          
          {/* Article 1 - Objet */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 1 : Objet</h2>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 mb-4">
                Les présentes Conditions Générales de Vente (CGV) définissent les conditions applicables à la vente par ECOCLIMA SARL de :
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-blue-900 mb-2">🌊 Produits principaux</h3>
                  <ul className="text-sm text-gray-700 space-y-1">
                    <li>• Générateurs d'eau atmosphérique</li>
                    <li>• Fontaines à eau atmosphérique</li>
                    <li>• Filtres et consommables</li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-green-900 mb-2">☀️ Options et services</h3>
                  <ul className="text-sm text-gray-700 space-y-1">
                    <li>• Kits autonomie solaire</li>
                    <li>• Installation et maintenance</li>
                    <li>• Service après-vente</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Article 2 - Produits */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 2 : Produits</h2>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 mb-4">
                Les caractéristiques des produits sont disponibles :
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>Sur notre site web <strong>www.ecoclima.energy</strong></li>
                <li>Dans les devis personnalisés</li>
                <li>Dans nos documents commerciaux</li>
              </ul>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                <p className="text-yellow-800">
                  <strong>Important :</strong> Les photos et visuels présentés n'ont pas de valeur contractuelle et sont fournis à titre indicatif.
                </p>
              </div>
            </div>
          </section>

          {/* Article 3 - Prix */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 3 : Prix</h2>
            <div className="bg-green-50 p-6 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-3">💰 Conditions tarifaires</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Les prix sont exprimés en <strong>euros (€)</strong>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                  Prix indiqués <strong>HT (Hors Taxes)</strong> et <strong>TTC (Toutes Taxes Comprises)</strong>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></span>
                  Les prix peuvent être modifiés à tout moment
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Frais de <strong>livraison</strong> et d'<strong>installation</strong> indiqués séparément sur le devis
                </li>
              </ul>
            </div>
          </section>

          {/* Article 4 - Commandes */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 4 : Commandes</h2>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 mb-4">
                Toute commande implique l'adhésion pleine et entière aux présentes CGV.
              </p>
              <div className="bg-red-50 border-l-4 border-red-400 p-4">
                <p className="text-red-800">
                  <strong>Réserve de droit :</strong> ECOCLIMA se réserve le droit de refuser une commande en cas de litige antérieur ou de non-paiement avec le client.
                </p>
              </div>
            </div>
          </section>

          {/* Article 5 - Paiement */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 5 : Paiement</h2>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 mb-4">
                Les modes de paiement acceptés sont :
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <div className="bg-blue-50 p-4 rounded-lg text-center">
                  <div className="text-2xl mb-2">🏦</div>
                  <h3 className="font-semibold text-gray-900">Virement bancaire</h3>
                </div>
                <div className="bg-green-50 p-4 rounded-lg text-center">
                  <div className="text-2xl mb-2">💳</div>
                  <h3 className="font-semibold text-gray-900">Carte bancaire</h3>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg text-center">
                  <div className="text-2xl mb-2">📝</div>
                  <h3 className="font-semibold text-gray-900">Chèque</h3>
                </div>
              </div>
              <p className="text-gray-700">
                Un <strong>acompte</strong> peut être demandé lors de la commande.
              </p>
            </div>
          </section>

          {/* Article 6 - Livraison et installation */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 6 : Livraison et installation</h2>
            <div className="bg-blue-50 p-6 rounded-lg">
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-blue-900 mb-2">🚚 Livraison</h3>
                  <p className="text-gray-700 text-sm">
                    Les délais de livraison mentionnés sont <strong>indicatifs</strong> et peuvent varier selon la disponibilité des produits.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-blue-900 mb-2">🔧 Installation</h3>
                  <p className="text-gray-700 text-sm">
                    L'installation est assurée par des <strong>techniciens agréés ECOCLIMA</strong>. Le client doit fournir les accès nécessaires au lieu d'installation.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Article 7 - Garantie et SAV */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 7 : Garantie et SAV</h2>
            <div className="prose prose-gray max-w-none">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-green-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-green-900 mb-3">⚖️ Garanties légales</h3>
                  <ul className="text-sm text-gray-700 space-y-1">
                    <li>• Garantie de conformité</li>
                    <li>• Garantie des vices cachés</li>
                  </ul>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-blue-900 mb-3">🛡️ Garantie commerciale</h3>
                  <ul className="text-sm text-gray-700 space-y-1">
                    <li>• <strong>2 ans</strong> pièces et main d'œuvre</li>
                    <li>• Garantie ECOCLIMA</li>
                  </ul>
                </div>
              </div>
              <div className="mt-4 bg-yellow-50 p-4 rounded-lg">
                <h3 className="font-semibold text-yellow-900 mb-2">🔧 Service après-vente</h3>
                <p className="text-gray-700 text-sm">
                  Le SAV est assuré en <strong>Guadeloupe</strong> par les équipes techniques d'ECOCLIMA.
                </p>
              </div>
            </div>
          </section>

          {/* Article 8 - Droit de rétractation */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 8 : Droit de rétractation</h2>
            <div className="bg-orange-50 p-6 rounded-lg">
              <h3 className="font-semibold text-orange-900 mb-3">⏰ Délai de rétractation</h3>
              <p className="text-gray-700 mb-3">
                Les clients <strong>particuliers</strong> disposent d'un délai de <strong>14 jours</strong> pour exercer leur droit de rétractation.
              </p>
              <div className="bg-red-100 p-3 rounded border-l-4 border-red-400">
                <p className="text-red-800 text-sm">
                  <strong>Exception :</strong> Ce droit ne s'applique pas aux produits installés ou utilisés pour des raisons sanitaires.
                </p>
              </div>
            </div>
          </section>

          {/* Article 9 - Responsabilité */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 9 : Responsabilité</h2>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 mb-4">
                La responsabilité d'ECOCLIMA est limitée dans les cas suivants :
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Mauvaise utilisation du produit par le client</li>
                <li>Installation non conforme par un tiers non agréé</li>
                <li>Cas de force majeure</li>
                <li>Non-respect des conditions d'utilisation</li>
              </ul>
            </div>
          </section>

          {/* Article 10 - Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 10 : Propriété intellectuelle</h2>
            <div className="bg-purple-50 p-4 rounded-lg">
              <p className="text-gray-700">
                Tous les éléments du site web <strong>www.ecoclima.energy</strong> sont protégés par le <strong>droit d'auteur</strong> et le <strong>Code de la propriété intellectuelle</strong>.
              </p>
            </div>
          </section>

          {/* Article 11 - Données personnelles */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 11 : Données personnelles</h2>
            <div className="bg-blue-50 p-4 rounded-lg">
              <p className="text-gray-700">
                Le traitement des données personnelles respecte la <Link to="/politique-confidentialite" className="text-blue-600 hover:text-blue-800 font-medium">Politique de confidentialité d'ECOCLIMA</Link>.
              </p>
            </div>
          </section>

          {/* Article 12 - Litiges */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 12 : Litiges</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-3">⚖️ Résolution des litiges</h3>
              <div className="space-y-3">
                <div className="flex items-center">
                  <span className="text-2xl mr-3">🤝</span>
                  <p className="text-gray-700">
                    <strong>1. Résolution amiable :</strong> Tentative de résolution amiable en priorité
                  </p>
                </div>
                <div className="flex items-center">
                  <span className="text-2xl mr-3">🏛️</span>
                  <p className="text-gray-700">
                    <strong>2. Compétence juridique :</strong> Tribunaux de Pointe-à-Pitre en cas d'échec
                  </p>
                </div>
                <div className="flex items-center">
                  <span className="text-2xl mr-3">🇫🇷</span>
                  <p className="text-gray-700">
                    <strong>3. Droit applicable :</strong> Droit français
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="border-t pt-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact</h2>
            <div className="bg-green-50 p-6 rounded-lg">
              <p className="text-gray-700 mb-4">
                Pour toute question concernant ces conditions générales de vente :
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="mailto:contact@ecoclima.energy"
                  className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  contact@ecoclima.energy
                </a>
                <a
                  href="tel:+590590197070"
                  className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  0590 19 70 70
                </a>
              </div>
            </div>
          </section>

        </div>
        
        {/* Navigation links */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/mentions-legales" 
            className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-center"
          >
            Mentions légales
          </Link>
          <Link 
            to="/politique-confidentialite" 
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-center"
          >
            Politique de confidentialité
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CGV;